import { Component } from '@angular/core'

import {
  CBD_NAV_INVESTMENTS,
  ConstantContent,
} from '../../../constants/constant.content'
import { ConstantUrls } from '../../../constants/constant.urls'
import { Fd3ValidationService } from '../../services/fd3-validation/fd3-validation.service'
import { UserLogonService } from '../../services/user-logon/user-logon.service'
import { VgnContentService } from '../../services/vgn-content/vgn-content.service'

@Component({
  selector: 'app-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss'],
})
export class GlobalHeaderComponent {
  content: any
  isLoggedOn = false

  constructor(
    private readonly vgnContentService: VgnContentService,
    private readonly userLogonService: UserLogonService,
    private readonly fd3ValidationService: Fd3ValidationService,
  ) {
    this.userLogonService.getUserLogonData().subscribe({
      next: (data) => {
        if (data) {
          this.isLoggedOn = data.isLoggedOn
          this.getContent()
        }
      },
    })
  }

  getContent() {
    this.vgnContentService.getVgnContent(this.isLoggedOn).subscribe({
      next: (data: any) => {
        const currentVGNScript = document.getElementById(
          ConstantContent.GLOBAL_HEADER_NAVBAR_SCRIPT_TAG_ID,
        )
        if (currentVGNScript) {
          document.body.removeChild(currentVGNScript)
        }
        this.markSiloSelected(data)
        this.content = data
        const vgnScript = this.buildScript()
        document.body.appendChild(vgnScript)
      },
    })
  }

  // eslint-disable-next-line complexity
  markSiloSelected(data: any) {
    if (
      !this.fd3ValidationService.isNullOrUndefined(data) &&
      !this.fd3ValidationService.isNullOrUndefined(data.navItems)
    ) {
      for (const item of data.navItems) {
        if (
          item.id === ConstantContent.NAV_ITEM_PROD_TOOL_SILO ||
          item.id === CBD_NAV_INVESTMENTS
        ) {
          item.selected = true
        }
        if (item.id === ConstantContent.NAV_ITEM_MY_HUB_SILO) {
          item.selected = false
        }
      }
    }
  }

  buildScript(): HTMLScriptElement {
    const scriptTag = document.createElement('script')
    scriptTag.type = ConstantContent.SCRIPT_TYPE
    scriptTag.id = ConstantContent.GLOBAL_HEADER_NAVBAR_SCRIPT_TAG_ID
    scriptTag.src = ConstantUrls.VGN_SRC
    return scriptTag
  }
}
